import * as React from 'react'
import {Downloadable} from '../Data/Downloadable'
import Button from 'material-ui-next/Button'
import CircularProgress from 'material-ui-next/Progress/CircularProgress'
import AlertError from 'material-ui/svg-icons/alert/error'
import FileAttachment from 'material-ui/svg-icons/file/attachment'

export function DownloadButton({downloadable, filename, onDownload}: {
    downloadable: Downloadable,
    filename: string,
    onDownload: () => void
}) {
    return (
        <Button
            disabled={downloadable.type === 'Loading'}
            onClick={onDownload}
        >
            {(() => {
                switch (downloadable.type) {
                    case 'Default':
                        return <FileAttachment/>
                    case 'Loading':
                        return <CircularProgress size={24}/>
                    case 'Failure':
                        return <AlertError/>
                }
            })()}
            {filename}
        </Button>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/DownloadButton.tsx